import { EVENT_TYPES } from 'consts';
import React, { useEffect, useState } from 'react'
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ReferenceLine } from "recharts";
import { timeFormatter } from 'utils/formaters';
import { ContinuesLabel } from '../Labels';

export default function ContinuesChart({ data, name, dataKey, unit, yTicks, xTicks, xLines, strokeColor, gridColor, gridOpacity }) {
    const [filteredData, setFilteredData] = useState([])
    const [showTooltip,setShowTooltip] = useState(true)
    
             const show = (value, index) => {
        const showLabel = value && filteredData[index] && (
            filteredData[index][EVENT_TYPES.SPO2] ||
            filteredData[index][EVENT_TYPES.BODY_TEMP] ||
            filteredData[index][EVENT_TYPES.BLOOD_PRESSURE_SYS]
        ) ? true : false;
        return showLabel;
    }
    
    useEffect(() => {
      filterData()
    }, [data])
    const renderLegend = (props) => {
        const { payload } = props;
        const { value } = payload[0]
        return (
            <div style={{ color: 'black' }} >
                <div> {value} </div>
                <small> {unit} </small>
            </div>
        )
    }

    function filterData() {
        const newData = data.filter(d => d[dataKey]);
        const finalData = [];
        for (let i = 0; i < newData.length; i++) {
            if (i === newData.length - 1) {
                finalData.push(newData[i])
                break;
            }
            let currentTime = newData[i].time;
            let nextTime = newData[i + 1].time;
            const timePast = (nextTime - currentTime) * 0.001;
            const timeToNotConnect = dataKey === 3 ? 60 : 30;
            if ((timePast / 60) > timeToNotConnect) {
                finalData.push(newData[i], { time: currentTime + 5000 });
                continue;
            }
            finalData.push(newData[i])
        }
        setFilteredData(finalData);
    }
    return (
        <ResponsiveContainer width="100%" height={200} >
            <LineChart data={filteredData} margin={{ right: 30, left: 150 }} >
                <CartesianGrid
                    strokeDasharray="3 3"
                    fill={gridColor}
                    fillOpacity={gridOpacity || "1"} />
                <XAxis
                    ticks={xTicks}
                    domain={[xTicks[0], xTicks[12]]}
                    dataKey="time" hide={true}
                    tickFormatter={timeFormatter}
                    type="number" />
                <YAxis ticks={yTicks} />
                {xLines.map(time =>
                    <ReferenceLine
                        key={time}
                        x={time}
                        stroke="#636E72" />)}
                <Legend
                    layout="vetical"
                    verticalAlign="middle"
                    wrapperStyle={{ position: 'absolute', left: 0 }}
                    content={renderLegend} />
                <Line
                    isAnimationActive={false}
                    type="monotone"
                    name={name}
                    dataKey={dataKey}
                    stroke={strokeColor}
                    strokeWidth={2}
                    dot={false}
                    activeDot={false}
                    label={<ContinuesLabel hideTooltip={setShowTooltip} strokeColor={strokeColor} show={show} />}
                    connectNulls={false}
                />
                { showTooltip &&
                  <Tooltip
                    cursor={false} 
                    labelFormatter={time => timeFormatter(time)} />  
                }
                
                {/* <Brush dataKey="name" height={30} stroke="#8884d8" /> */}
            </LineChart>
        </ResponsiveContainer>
    )
}